import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';

import ViewImage from '../Img/components/ViewImage';

function ProductCard({
  className,
  imageSrc,
  imageSize,
  label,
  price,
  description,
  quantity,
  ...rest
}) {
  return (
    <div
      className={cn(
        'border rounded-lg flex flex-row overflow-hidden bg-gray-50 bg-opacity-50',
        className
      )}
      {...rest}
    >
      <div className="relative bg-gray-100 flex items-center justify-center">
        <ViewImage
          src={
            imageSrc
              ? `${imageSrc}-/format/jpeg/-/progressive/yes/-/preview/400x400/`
              : ''
          }
          hoverLabel="View"
          containerClassName="h-20"
          className="object-cover object-center h-20 w-20 md:w-24"
        />
        <div className="absolute left-0 bottom-1 mb-px">
          <span className="p-2 rounded-tr bg-blue-100 text-blue-600 text-sm font-bold">
            {quantity}x
          </span>
        </div>
      </div>
      <div className="flex-1 p-4">
        <div className="flex flex-col xl:flex-row font-medium text-sm mb-1">
          <div>{label}</div>
          <div className="font-semibold xl:ml-auto">{price}</div>
        </div>
        <div className="text-gray-500 text-xs md:text-sm">{description}</div>
      </div>
    </div>
  );
}

ProductCard.defaultProps = {
  imageSrc: '',
  label: '',
  price: '',
  description: '',
  className: '',
  imageSize: false,
  quantity: 0,
};

ProductCard.propTypes = {
  imageSrc: PropTypes.string,
  label: PropTypes.string,
  price: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.element,
  ]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  className: PropTypes.string,
  imageSize: PropTypes.oneOfType([
    PropTypes.PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
    ]),
    PropTypes.shape({
      height: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    }),
  ]),
  quantity: PropTypes.number,
};

export default ProductCard;
